import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
var RulesWrapper = function RulesWrapper(_ref) {
  var children = _ref.children,
    remainigProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(motion.div, _extends({
    initial: false,
    layout: true
  }, remainigProps), /*#__PURE__*/React.createElement(AnimatePresence, null, /*#__PURE__*/React.createElement(motion.div, {
    layout: "position"
  }, children)));
};
RulesWrapper.defaultProps = {};
export default RulesWrapper;